
import { mapState } from 'vuex'
import { CartItem } from '@/models/checkout'

export default {
  computed: {
    ...mapState({
      wishlist: state => state.favourites.wishlist,
      licenses: state => state.checkout.licenses
    }),
    hasMoreFavourites () {
      return this.wishlist && this.wishlist.length > this.favouritesLimit
    },

    cartItems () {
      return this.wishlist.map(w => new CartItem(w.diagram))
    },

    displayedFavourites() {
      if (!this.expandFavourites) {
        return this.cartItems.slice(0, this.favouritesLimit)
      } else {
        return this.cartItems
      }
    },

    counter () {
      let counter = this.favouritesLimit;
      if (this.expandFavourites) {
        if (this.hasMoreFavourites) {
          counter = this.wishlist.length;
        } else {
          counter = this.favouritesLimit
        }
      } else {
        counter = this.wishlist.length > this.favouritesLimit ? this.favouritesLimit : this.wishlist.length;
      }
      return counter;
    },
    
    expandButtonText () {
      if (this.expandFavourites) {
        return 'Show less'
      } else {
        return 'Show all</span>'
      }
    }
  },
  data () {
    return {
      expandFavourites: false,
      favouritesLimit: 4
    }
  }
}

